import { useState } from "react";
import { Flex, Tabs } from "antd";
import { useHasPermission } from "../../hooks/useHasPermission";
import { PERMISSIONS } from "../../constants/permission";
import "./system-default.scss";
import RuleDefaultPage from "./components/rule-default-tab";
import TermDefault from "./components/term-default-tab";
import GeneralSettingPage from "./components/general-setting";

const DefaultTabKey = "terms";

const SystemDefaultPage: React.FC = () => {
  const hasSystemDefaultViewer = useHasPermission([PERMISSIONS.SYSTEM_DEFAULT_VIEWER, PERMISSIONS.SYSTEM_DEFAULT_EDITOR]);
  const [activeTabKey, setActiveTabKey] = useState(DefaultTabKey);

  const onChangeTab = async (newKey: string) => {
    setActiveTabKey(newKey);
  };

  const tabItems = [
    {
      label: "Supplier Payment Terms",
      key: "terms",
      children: <TermDefault />,
    },
    {
      label: "Supplier Rules",
      key: "rules",
      children: <RuleDefaultPage />,
    },
    {
      label: "General Settings",
      key: "generalSettings",
      children: <GeneralSettingPage />,
    },
  ];

  return (
    <div className="system-default-page">
      <Flex justify="space-between" align="center" gap={16}>
        <h2 className="title-page">System Default</h2>
      </Flex>
      {hasSystemDefaultViewer && <Tabs activeKey={activeTabKey} onChange={onChangeTab} items={tabItems} />}
    </div>
  );
};

export default SystemDefaultPage;
